/**
 * useAuth hook
 *
 * Custom hook for consuming auth context in components.
 * Ensures the hook is used within an AuthProvider.
 */

import { useContext } from 'react';
import type { AuthContextType } from './types';
import { AuthContext } from './AuthProvider';

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
};
